import React, { useEffect, useState } from "react";

import { FloatInput, FloatSelectObject } from "../Floating";
import { useDispatch, useSelector } from "react-redux";
import { getCoursesList } from "../../appRedux/actions/courses";
import { getPlatformsList } from "../../appRedux/actions/platforms";
import FloatSelectSingle from "../Floating/FloatSelectSingle";

function Filter({ initialFetchComplete }) {
  const dispatch = useDispatch();

  const { queryInfo, courseFilters, setOldQueryInfo } = useSelector(
    (state) => ({
      queryInfo: state.courses.queryInfo || {},
      courseFilters: state.courses.courseFilters || {},
      setOldQueryInfo: state.courses.setOldQueryInfo,
    })
  );
  const dbPlatformList = useSelector((state) => state.platforms.platformList || []);

  const [searchText, setSearchText] = useState("");
  const [platform, setPlatform] = useState([]);
  const [category, setCategory] = useState([]);
  const [affiliated, setAffiliated] = useState("all");
  const [sortBy, setSortBy] = useState(queryInfo["sort-by"] || "rating:desc");

  const SORT_OPTIONS = [
    { code: "rating:desc", name: "Rating: High to Low" },
    { code: "rating:asc", name: "Rating: Low to High" },
    { code: "updated_at:desc", name: "Recently Updated" },
    { code: "created_at:desc", name: "Recently Added" },
    { code: "price:asc", name: "Price: Low to High" },
    { code: "price:desc", name: "Price: High to Low" },
    { code: "title:asc", name: "Title: A to Z" },
    { code: "title:desc", name: "Title: Z to A" },
  ];

  const [categoriesList, setCategoriesList] = useState(courseFilters.category);
  const [modeList, setModeList] = useState(courseFilters.mode);
  const [platformList, setPlatformList] = useState(courseFilters.platform);
  const [affiliationList, setAffiliationList] = useState(
    courseFilters.affiliation
  );
  const [courseTypeList, setCourseTypeList] = useState(
    courseFilters.course_type
  );
  const [languageList, setLanguageList] = useState(courseFilters.language);
  const [ratingList, setRatingList] = useState(courseFilters.rating);
  const [levelList, setLevelList] = useState(courseFilters.level);

  useEffect(() => {
    dispatch(getPlatformsList({ page: 1, size: 100 }));
  }, [dispatch]);

  useEffect(() => {
    if (dbPlatformList && dbPlatformList.length > 0) {
      setPlatformList(dbPlatformList);
    } else {
      setPlatformList(courseFilters.platform);
    }
  }, [dbPlatformList, courseFilters.platform]);

  useEffect(() => {
    setCategoriesList(courseFilters.category);
    setModeList(courseFilters.mode);
    setAffiliationList(courseFilters.affiliation);
    setCourseTypeList(courseFilters.course_type);
    setLanguageList(courseFilters.language);
    setRatingList(courseFilters.rating);
    setLevelList(courseFilters.level);
  }, [courseFilters]);

  useEffect(() => {
    if (setOldQueryInfo && queryInfo) {
      if (queryInfo["sort-by"]) {
        setSortBy(queryInfo["sort-by"]);
      }
      if (queryInfo.q) {
        setSearchText(queryInfo.q);
      } else {
        setSearchText("");
      }

      if (queryInfo.param && queryInfo.value) {
        const params = Array.isArray(queryInfo.param) ? queryInfo.param : [queryInfo.param];
        const values = Array.isArray(queryInfo.value) ? queryInfo.value : [queryInfo.value];

        const merchantIdx = params.indexOf("merchants");
        if (merchantIdx !== -1 && values[merchantIdx]) {
          setPlatform(values[merchantIdx].split("|"));
        } else {
          setPlatform([]);
        }

        const categoryIdx = params.indexOf("categories");
        if (categoryIdx !== -1 && values[categoryIdx]) {
          setCategory(values[categoryIdx].split("|"));
        } else {
          setCategory([]);
        }

        const affiliatedIdx = params.indexOf("is_affiliated");
        if (affiliatedIdx !== -1) {
          const affValue = values[affiliatedIdx];
          if (affValue === true || affValue === "true") {
            setAffiliated("Impact");
          } else if (affValue === false || affValue === "false") {
            setAffiliated("Direct");
          }
        } else {
          setAffiliated("all");
        }
      } else {
        setPlatform([]);
        setCategory([]);
        setAffiliated("all");
      }
    }
  }, [queryInfo, setOldQueryInfo]);

  useEffect(() => {
    if (initialFetchComplete) {
      const paramsArray = [];
      const valuesArray = [];

      if (platform.length > 0) {
        paramsArray.push("merchants");
        valuesArray.push(platform.join("|"));
      }
      if (category.length > 0) {
        paramsArray.push("categories");
        valuesArray.push(category.join("|"));
      }
      if (affiliated === "Impact") {
        paramsArray.push("is_affiliated");
        valuesArray.push(true);
      } else if (affiliated === "Direct") {
        paramsArray.push("is_affiliated");
        valuesArray.push(false);
      }

      const timeout = setTimeout(() => {
        dispatch(
          getCoursesList({
            page: 1,
            size: queryInfo.size || 10,
            "sort-by": sortBy,
            q: searchText === "" ? undefined : searchText,
            param: paramsArray.length > 0 ? paramsArray : undefined,
            value: valuesArray.length > 0 ? valuesArray : undefined,
          })
        );
      }, 500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [searchText, category, platform, affiliated, sortBy]);

  return (
    <div className="row filter-row align-items-center">
      <div className="col-sm-6 col-md-3 pb-2">
        <FloatInput
          label="Search Courses (Title, Tags, Categories...)"
          value={searchText}
          name="searchText"
          id="inputCustom"
          alwaysFloat={true}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
        />
      </div>
      <div className="col-sm-6 col-md-2 pb-2">
        <div className="form-group form-focus select-focus m-0">
          <FloatSelectObject
            label="Platform"
            value={platform}
            name="platform"
            id="inputCustom"
            tag2="code"
            alwaysFloat={true}
            onChange={(value) => {
              setPlatform(value);
            }}
            showSearch={true}
            options={platformList}
          />
        </div>
      </div>

      <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus m-0">
          <FloatSelectObject
            label="Category"
            value={category}
            name="category"
            id="inputCustom"
            tag2="name"
            showSearch={true}
            alwaysFloat={true}
            onChange={(value) => {
              setCategory(value);
            }}
            options={categoriesList}
          />
        </div>
      </div>

      <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus m-0">
          <FloatSelectSingle
            label="Affiliated"
            value={affiliated}
            name="affiliated"
            id="inputCustom"
            tag2="name"
            alwaysFloat={true}
            onChange={(value) => {
              setAffiliated(value);
            }}
            options={[
              { code: "all", name: "All" },
              { code: "Impact", name: "Impact" },
              { code: "Direct", name: "Direct" },
            ]}
          />
        </div>
      </div>

      <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus m-0">
          <FloatSelectSingle
            label="Sort By"
            value={sortBy}
            name="sortBy"
            id="inputCustom"
            tag2="code"
            alwaysFloat={true}
            onChange={(value) => {
              setSortBy(value);
            }}
            options={SORT_OPTIONS}
          />
        </div>
      </div>

      <div className="col-sm-6 col-md-1 pb-2">
        <button
          className="btn btn-outline-secondary btn-block w-100 px-1 py-2 font-weight-bold"
          title="Clear Filters"
          onClick={() => {
            setSearchText("");
            setCategory([]);
            setPlatform([]);
            setAffiliated("all");
            setSortBy("rating:desc");
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
}

Filter.propTypes = {};

export default Filter;
